import { defineComponent as _defineComponent } from 'vue'
import { GET } from '@/admin-shared-modules/utils/ajax'
import { BookTypeRoot, LibType, MagazineTypeRoot } from '@/consts'
import { ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'resource-form-shared',
  props: {
    edit: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  edit: any
};



const { edit } = props

const projectList = ref<{ id: number; name: string }[]>([])
async function fetchProjectList() {
  const res = await GET('labels', {})
  projectList.value = res.data
}
fetchProjectList()

// Export
function getForm() {
  return this.$refs.form
}
expose({ getForm })

return { __sfc: true,props, edit, projectList, fetchProjectList, getForm, BookTypeRoot, LibType, MagazineTypeRoot }
}

})